module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/nyls-47af4ceb12f213396aee0f60018a3b89.png";